import { initAddress } from '../../components/address'

function initApplicantUpdate() {
  initAddress()
}

export { initApplicantUpdate }
